import defs from '../_core/defs.js';
// iterates over data keys looking for a property with given value
// and returns a key of found property
export default function keyOf(value) {
  var def = defs.get(this);
  /* istanbul ignore if */
  if (!def) {
    return null;
  }
  var keysArray = Object.keys(def.keys);
  for (var i = 0; i < keysArray.length; i++) {
    var key = keysArray[i];
    if (this[key] === value) {
      return key;
    }
  }
  return null;
}